// extracted by mini-css-extract-plugin
export default {"cls1":"AccountMenu-cls1_JZy","cls2":"AccountMenu-cls2_J4A AccountMenu-cls1_JZy"};